var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"7","height":"10","viewBox":"0 0 7 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.2124 6.80566L0.212402 12.8678L0.212403 0.743486L6.2124 6.80566Z","fill":"#36474F"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }